import { render, staticRenderFns } from "./Firme.vue?vue&type=template&id=210c19a5&scoped=true"
import script from "./Firme.vue?vue&type=script&lang=js"
export * from "./Firme.vue?vue&type=script&lang=js"
import style0 from "./Firme.vue?vue&type=style&index=0&id=210c19a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210c19a5",
  null
  
)

export default component.exports